import { render, staticRenderFns } from "./AppointmentDetails.vue?vue&type=template&id=0cb18784&"
import script from "./AppointmentDetails.vue?vue&type=script&lang=js&"
export * from "./AppointmentDetails.vue?vue&type=script&lang=js&"
import style0 from "./AppointmentDetails.vue?vue&type=style&index=0&id=0cb18784&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports